import {Flight} from './flight.model';
import {Reservation} from './reservation.model';

export class PassengerCreate {
    public id: number;
    public first_name: string;
    public last_name: string;
    public type: string;
    public reservation_id: number;
    public created: string;

    constructor(first_name: string, last_name: string, type: string, reservation_id: number) {
        this.first_name = first_name;
        this.last_name = last_name;
        this.type = type;
        this.reservation_id = reservation_id;
    }
}

export class PassengerUpdate {
    public id: number;
    public reservation_id: number;
    public first_name: string;
    public last_name: string;
    public type: string;
    public created: string;

    constructor(id: number, reservation_id: number, first_name: string, last_name: string, type: string) {
        this.id = id;
        this.reservation_id = reservation_id;
        this.first_name = first_name;
        this.last_name = last_name;
        this.type = type;
    }
}

export class Passenger {
    public id: number;
    public first_name: string;
    public last_name: string;
    public type: string;
    public flight: Flight;
    public reservation: Reservation;
    public created: string;

    constructor(id: number, first_name: string, last_name: string, type: string, reservation: Reservation,
                flight?: Flight) {
        this.id = id;
        this.first_name = first_name;
        this.last_name = last_name;
        this.type = type;
        this.reservation = reservation;
        this.flight = flight;
    }
}
